
    import * as qrcode from 'qrcode';
    import { Buffer } from 'buffer';
    global.qrcode = qrcode;
    global.Buffer = Buffer;
  